export interface PlanProperty {
  [key: string]: boolean | string;
}

export enum Interval {
  MONTH = "month",
  YEAR = "year",
  LIFETIME = "lifetime"
}

export interface Plan {
  id: number;
  name: string;
  price: string;
  interval: Interval;
  interval_count?: number;
  description: string;
  properties: PlanProperty;
  type: string;
  planIndex: number;
  originalPrice: number;
  listingSearches: number;
  keywordsSearches: number;
  marketSearches: number;
  storeSearches: number;
}
